import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChange } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { Notification, NotificationType } from "../../../../../models/notification";
import { NotificationDeterminant } from "../../../../../models/notification-determinant";
import { Tag } from "../../../../../models/tag";
import { TagControllerService } from "../../../../../services/form-controller/tag-controller.service";
import { NotificationControllerService } from "../../../../../services/message-controller/notification-controller.service";
import { NotificationDeterminantControllerService } from "../../../../../services/message-controller/notification-determinant-controller.service";
import { Store } from "../../../../../services/store.service";
import { BaseError } from "../../../base-error";

@Component({
  selector: "description-notification",
  templateUrl: "./description-notification.component.html",
  providers: [NotificationControllerService, ToastrService, TagControllerService],
})
export class DescriptionNotificationComponent extends BaseError implements OnChanges, OnInit {
  @Input() public notification = new Notification();
  @Input() public serviceId;
  @Input() public showCancelButton = false;
  @Output() public modalClosedEvent = new EventEmitter();
  @Output() public formSubmit = new EventEmitter();
  @Output() public editCancel = new EventEmitter();
  public showDeterminantModal = false;
  public tagItems: Tag[] = [];
  public selectedTagItems: Tag[] = [];
  public isLoading: boolean = false;
  public content: any;

  constructor(private notificationControllerService: NotificationControllerService,
              private notificationDeterminantController: NotificationDeterminantControllerService,
              private router: Router,
              public store: Store,
              toastr: ToastrService,
              private route: ActivatedRoute, private tagController: TagControllerService) {
    super(toastr);
  }

  public ngOnInit() {
    this.reloadGroupList();
    this.loadAllTags();
    this.setSeledtedTag();
    this.route.params.subscribe((params) => {
      this.serviceId = params.serviceId;
    });
  }

  public responseSuccessful(message) {
    this.toastr.success(message);
  }

  public openDeterminantModal() {
    if (!this.notification || !this.notification.id) {
      this.notification.notificationType = NotificationType.GUIDE;
      this.notificationControllerService.createNotification(this.serviceId, this.notification).subscribe(
        (data) => {
          this.notification = data;
          this.showDeterminantModal = true;
        },
        (error) => this.showErrorMessageWithTitle("Error HTTP Post Notification add new!", error),
      );
    } else {
      this.showDeterminantModal = true;
    }
  }

  public ngOnChanges(changes: { [propName: string]: SimpleChange }) {
    this.setSeledtedTag();
  }

  public addNewNotification() {
    if (!this.isLoading) {
      this.isLoading = true;
      this.notification.notificationType = NotificationType.GUIDE;
      this.notificationControllerService.createNotification(this.serviceId, this.notification).subscribe(
        (data) => {
          this.formSubmit.emit({ add: true });
          this.responseSuccessful("Guide message created!");
        },
        (error) => this.showErrorMessageWithTitle("Error HTTP Post Notification add new!", error),
        () => this.isLoading = false,
      );
    }
  }

  public saveNotification() {
    if (!this.isLoading) {
      this.isLoading = true;
      this.notification.notificationType = NotificationType.GUIDE;
      this.notificationControllerService.saveNotification(this.notification).subscribe(
        (data) => {
          this.formSubmit.emit({ update: true });
          this.responseSuccessful("Guide message saved!");
        },
        (error) => this.showErrorMessageWithTitle("Error HTTP Post Guide save!", error),
        () => this.isLoading = false,
      );
    }
  }

  public deleteNotification(isConfirmed) {
    if (isConfirmed) {
      this.notificationControllerService.deleteNotification(this.notification.id).subscribe(
        (data) => {
          this.responseSuccessful("Guide message deleted!");
          this.formSubmit.emit({ delete: true });
        },
        (error) => this.showErrorMessage(error != null && error.error != null ? error.error.errors[0] : error),
      );
    }
  }

  public eventCloseRegistrationDeterminantWindow(doReload: boolean) {
    if (doReload) {
      this.showDeterminantModal = false;
      this.reloadGroupList();
      this.router.navigate(["/services/" + this.serviceId + "/notification/" + this.notification.id]);
    }
  }

  public reloadGroupList() {
    if (this.notification && this.notification.id) {
      this.notificationControllerService.getNotification(this.notification.id).subscribe(
        (data) => {
          this.notification = data;
        },
      );
    }
  }

  public specifyAndOrVisibility(list: NotificationDeterminant[]) {
    let i = 0;
    list.forEach((group) => {
      group.andOrIsDisabled = i === 0;
      i = i + 1;
    });
  }

  public mandatoryGroupAndOrTypeChanged(andOrType: string, i) {
    const group = this.notification.determinants[i];
    group.andOrType = andOrType;
    this.saveGroup(group);
  }

  public saveGroup(group: NotificationDeterminant) {
    this.notificationDeterminantController.saveNotificationDeterminantGroup(group).subscribe(
      (data) => this.responseSuccessful("Determinant group saved successfully!"),
      (error) => this.showErrorMessage(error),
    );
  }

  public deleteGroup(isConfirmed, groupId) {
    if (isConfirmed) {
      this.notificationDeterminantController.deleteDeterminant(groupId).subscribe(
        (data) => {
          this.responseSuccessful("Determinant group deleted successfully!");
          this.reloadGroupList();
        },
      );
    }
  }

  public loadAllTags() {
    this.tagController.getTagList().subscribe(
      (data) => this.tagItems = data,
    );
  }

  public setSeledtedTag() {
    this.selectedTagItems = [];
    if (this.notification && this.notification.tag) {
      const selectedItem = this.tagItems.find(((item) => item.name === this.notification.tag));
      if (selectedItem) {
        this.selectedTagItems.push(selectedItem);
      }
    }
  }

  public onTagAdded(tag: Tag) {
    if (tag.id === tag.name) {
      tag.id = undefined;
    }
    if (tag.id === undefined) {
      this.tagController.createTag(tag).subscribe(
        (data) => {
          tag = data;
        },
        (error) => this.showErrorMessage(error),
      );
    }
  }

  public dataChangedEvent(event) {
    if (event && event.length > 0) {
      this.notification.tag = event[0].name;
      this.selectedTagItems[0] = event[0];
    } else {
      this.notification.tag = undefined;
      this.selectedTagItems = [];
    }
  }

  public countNumberOfDeterminants() {
    if (this.notification.jsonDeterminants) {
      const parse = JSON.parse(this.notification.jsonDeterminants);
      if (parse.length === 0) {
        return 0;
      }
      let num = 0;
      parse.forEach((it) => num += it.items.length);
      return num;
    }
    return 0;
  }

  public closeLayer() {
    this.editCancel.emit();
  }

  public closeEditDet() {
    this.store.state.common.determinantSection.topLayer = "list";
    this.store.state.common.determinantSection.determinant = {};
  }
}
